export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "search.worker-6cb8195992d56c76f2f0.worker.js");
}
